<template>
  <el-dialog :append-to-body="true" title="选择商品" :visible.sync="dialogVisible" width="50%" @close="$emit('update:visible',false)">
    <div class="weui-cell mb15 pl0 pr0">
      <div class="weui-cell__bd gray999">选择商品</div>
      <div class="weui-cell__ft">
        <el-button type="primary" :disabled="selectRadioId!=''?false:true" @click="confirmSelect" size="small">确定选择</el-button>
      </div>
    </div>  
    <div class="shenheable">
      <!--ref="table"   @selection-change="handleSelectionChange"  @current-change="handleCurrentChange"-->
    <el-table   :inline="true" :data="tableData" style="width: 100%"    @row-click="rowClick">
      <!-- <el-table-column width="55" type="selection"></el-table-column> -->
      <el-table-column  label="" width="55">
        <template slot-scope="scope" >
						 <el-radio  v-model="selectRadioId" :lable="scope.row.id"  @click.native.prevent="onRadioChange(scope.row.id)"> &nbsp;</el-radio>
					</template>
      </el-table-column>
      <!-- <el-table-column
                label="分类名称"
                prop="name">
        </el-table-column> -->
        <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column> 
        <el-table-column label="商品图片" align="center">
          <template slot-scope="scope">
            <div class="td_img">
              <img :src="scope.row.goods_thumb" alt/>
            </div>
          </template>
        </el-table-column>
        <el-table-column
                label="商品数量"
                prop="goods_number">
        </el-table-column>
    
        <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
        <el-table-column prop="base_sales" label="销量" align="center"></el-table-column>
        <el-table-column prop="goods_number" label="库存" align="center"></el-table-column> 
      </el-table>
      <!-- 
 -->
       
      <!-- <el-table-column prop="name" label="员工名称"></el-table-column>
      <el-table-column prop="pic" label="头像">
        <template slot-scope="scope" align="center">
						<img :src="scope.row.pic || 'static/img/userDefult.png'" alt width="60px" height="60px" />
					</template>
      </el-table-column>
      <el-table-column prop="position" label="职位"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column> -->
 
    </div>
    <div class="pag_wrap" style="margin-top: 15px">
      <el-pagination
        background
        :page-size="page.page_size"
        :current-page="page.pageindex"
        layout="total, prev, pager, next"
        :total="page.total"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div> 
  </el-dialog>  
</template>

<script>
import { pagination } from "@/util/util.js";
import api from "@/api.js";
export default {
  name: 'shenheDialog',
  props: ['visible'],
  data() {
    return {
      selectRadioId:'',//选中的id
      dialogVisible: false,
      tableData: [],
      checkList: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total,
        current_page: pagination.current_page,
        page_size: pagination.page_size,
        total_rows: pagination.total_rows
      },
      listData: {
        name: '',
        page: 1
      },
      formdata: {
          check_type: 0,
          name: "",
          cat_id: [],
          goods_type: 0
        },
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      if (this.visible) {
        this.selectRadioId = ''  
        this.listData.page = 1;
        this.initFn();
      }
    }
  },
  methods: {
    rowClick(row){
      this.selectRadioId = row.id
      this.checkList = row

    },
    initFn() {
      let params = {
          page: this.page.pageindex,
          check_type: this.formdata.check_type,
          goods_type: this.formdata.goods_type,
          name: this.formdata.name,
          size:6,
          cat_id: this.formdata.cat_id[this.formdata.cat_id.length - 1]
        };
      this.axios
        .post(api.goods_index , params)
        .then(response => {
          if (response.data.code == 0) {
                this.tableData = response.data.list;
                this.page.total = response.data.all_page;
              } else {
                this.page.total = 0;
              }
          // if (response.data.code == 0) {
          //   this.tableData = response.data.result;
          //   response.data.page.current_page = parseInt(response.data.page.current_page);
          //   this.page = response.data.page;        
          // } 
        }).catch(() => {})
    },
    // 分页
    pageIndexChange(pageindex) {
      // this.listData.page = pageindex;
      this.page.pageindex = pageindex;
      this.initFn();
    },
    // handleSelectionChange(val) {
    //   this.checkList = val;
    // },
    confirmSelect() {
      let obj = [];
      // for (let i = 0; i < this.checkList.length; i++) {
      //   obj.push({id: this.checkList[i].id, title: this.checkList[i].name});
      // }
      obj.push({id: this.checkList.id, goods_name: this.checkList.goods_name});

      this.$emit('updatePageInfo', obj);
      this.$emit('update:visible', false);
    },
   onRadioChange(e) {
     // 当点击已经选中的把 activeModel 置空，就是取消选中，并返回
      if (this.activeModel === e) {
        this.activeModel = ''
        return
      }
     // 不是选中，选中当前点击 Radio
      this.activeModel = e
     // 选中操作
    }
  }
}
</script>